<template>
<div>
<ul ref="sideTabs" >
  <slot></slot>
</ul>
</div>
</template>

<script>
export default {

  data(){
       return{
           shouldExpand: false
       }
    },

  mounted() {

      this.$refs.sideTabs.addEventListener("mouseover", () => {
         this.shouldExpand = true;
       });

        this.$refs.sideTabs.addEventListener("mouseout", () => {
          this.shouldExpand = false;
        });
  },
  methods:{

  }

}
</script>

<style scoped>
ul{
    list-style: none;
    background-color: #252733;
    position: sticky;
    top: 0;
    height: 100vh;
    z-index: 5;
    margin: 0;
    padding: 100px 0px;
    font-family: roboto;
}
</style>